/**
 * Gets the hash value of the given location.
 * @param  {Object} location
 * @returns {string}
 */
export default function getHashValueLocationUtil (location) {
  return (location?.hash || '').slice(1)
}
